/* istanbul ignore file */
export { default } from './IconFeatureCard';
